// extracted by mini-css-extract-plugin
module.exports = {"horizontal":"styles_horizontal__4cnz3","vertical":"styles_vertical__CRf25"};